import { featuresResource } from '@atlassian/jira-router-resources-service-project-features/src/services/index.tsx';
import type { FeaturesData } from '@atlassian/jira-router-resources-service-project-features/src/types.tsx';
import { useResource } from '@atlassian/react-resource-router';

const useServiceProjectFeatures = () => useResource<FeaturesData | null>(featuresResource);

export default useServiceProjectFeatures;
